import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuestionState {
  private questionSource = new BehaviorSubject<any>(null);
  currentQuestion$ = this.questionSource.asObservable();

  private chatHistory = new BehaviorSubject<any>(null);
  updatedChatHistory$ = this.chatHistory.asObservable();


  setQuestion(question:any){
    this.questionSource.next(question);
  }

  setChatHistory(chatHistory:any){
    console.log(chatHistory);
    this.chatHistory.next(chatHistory);
  }
  
}
